// Page À propos - Présente l'application SmoFR et ses objectifs
import React from "react";
import { useLanguage } from "../utils/LanguageContext";

const textContent = {
  fr: {
    title: "À propos",
    description: `La plateforme Observatoire de la mobilité gérée par le Service de la
            mobilité de l'État de Fribourg a été conçue pour centraliser et
            organiser des données et informations clés utiles aux projets et initiatives en
            matière de mobilité. Vous y trouverez un répertoire complet de liens
            et de documentations couvrant des sujets allant des tableaux de bord
            analytiques (Abonnements TP, Accidents de la circulation, etc.) à des
            indicateurs utiles et parlants. Que vous soyez à la recherche de
            données pour un nouveau projet, d'informations sur les API (Interface de Programmation d'Application)
            disponibles, ou de directives pour utiliser nos tableaux de bord
            internes, cette plateforme est votre point de référence pour accéder
            rapidement et efficacement à ces ressources.`,
  },
  de: {
    title: "Über uns",
    description: `Die vom Mobilitätsamt
            des Kantons Freiburg betriebene Plattform „Observatoire de la
            mobilité“ wurde entwickelt, um wichtige Ressourcen im Zusammenhang
            mit Mobilitätsprojekten und -initiativen zu bündeln und zu
            strukturieren. Dort finden Sie ein umfassendes Verzeichnis mit Links
            und Dokumentationen zu Themen, die von analytischen Dashboards
            (ÖV-Abonnemente, Verkehrsunfälle usw.) bis hin zu nützlichen und
            aussagekräftigen Indikatoren reichen. Ganz gleich, ob Sie Daten für
            ein neues Projekt, Informationen zu verfügbaren APIs oder
            Anleitungen zur Nutzung unserer internen Dashboards suchen – diese
            Plattform ist Ihre Anlaufstelle für den schnellen und effizienten
            Zugriff auf diese Ressourcen.`,
  },
};

export default function About() {
  const { language } = useLanguage();
  const t = textContent[language]; // sélectionne fr ou de automatiquement

  return (
    <div className="flex-grow">
      <div className="w-full max-w-screen-xl mx-auto p-4">
        <h2 className="text-2xl font-semibold mb-4">{t.title}</h2>
        <p>{t.description}</p>
      </div>
    </div>
  );
}
